<div class="h-100-p w-100-p attachment-root" cdkDrag cdkDragRootElement=".cdk-overlay-pane">

    <!-- HEADER -->
    <div fxLayout="row" fxLayoutAlign="start center" class="header attachment-header">
        <div class="example-handle" cdkDragHandle>
            <svg style="pointer-events: stroke; color: rgb(8, 72, 83);" width="24px" fill="currentColor"
                viewBox="0 0 24 24">
                <path
                    d="M10 9h4V6h3l-5-5-5 5h3v3zm-1 1H6V7l-5 5 5 5v-3h3v-4zm14 2l-5-5v3h-3v4h3v3l5-5zm-9 3h-4v3H7l5 5 5-5h-3v-3z">
                </path>
                <path d="M0 0h24v24H0z" fill="none"></path>
            </svg>
        </div>
        <div fxFlex class="attachment-title">
            <h1 fxLayoutAlign="center center" mat-dialog-title>Anexos</h1>
            <h2 fxLayoutAlign="center center" class="text-truncat">
                {{data.patient?.person.name}}
            </h2>
        </div>
        <button mat-raised-button (click)="closeModal()" title="Fechar" color="accent">
            <mat-icon>close</mat-icon>
        </button>
    </div>

    <!-- BODY -->
    <div fxLayout="row" fxLayout.lt-md="column" class="h-100-p attachment-body"
        [class.mobile-history-open]="showHistoryMobile">

        <!-- LEFT SIDE (Form + Preview) -->
        <div fxFlex.lt-md="100" fxFlex.gt-md="65" fxLayout="column" class="left-side"
            *ngIf="!isMobileView() || !showHistoryMobile">

            <!-- FORM -->
            <form [formGroup]="AttachmentGroup" class="form">
                <mat-form-field appearance="outline" class="w-100-p">
                    <mat-label>Nome do Arquivo</mat-label>
                    <input matInput type="text" formControlName="name">
                    <button matSuffix mat-icon-button aria-label="Clear" (click)="fileInput.click()">
                        <mat-icon>attach_file</mat-icon>
                    </button>
                </mat-form-field>
                <input type="file" [disabled]="attachment.id" #fileInput hidden (change)="onFileSelected($event)">
            </form>

            <!-- PREVIEW -->
            <div class="preview h-80-p" style="border: 1px dashed rgb(2, 62, 65);" fxLayoutAlign="center center">

                <!-- PDF -->
                <ngx-extended-pdf-viewer *ngIf="pdfSrc && file == 'pdf'" class="h-100-p w-100-p" [src]="pdfSrc"
                    [showHandToolButton]="true" [handTool]="false" [contextMenuAllowed]="false"
                    [showSidebarButton]="false" showPropertiesButton="false" useBrowserLocale="true" [zoom]="zoom">
                </ngx-extended-pdf-viewer>

                <!-- IMAGE -->
                <img *ngIf="pdfSrc && file == 'image'" [src]="pdfSrc" alt="Preview"
                    style="max-width:100%; max-height:100%; object-fit:contain;">

                <!-- VIDEO -->
                <video *ngIf="pdfSrc && file == 'video'" controls [src]="pdfSrc"
                    style="border: solid; border-radius: 10px; border-color: #006064; width:100%; height:100%;">
                    Seu navegador não suporta a tag de vídeo HTML5.
                </video>

                <!-- OTHER FILES -->
                <span *ngIf="pdfSrc && file == 'notFile'" fxLayoutAlign="center center" class="h-100-p w-100-p">
                    <h2>Não há visualização para este tipo de arquivo.</h2>
                </span>
            </div>

            <!-- BUTTONS -->
            <div fxLayout="row" fxLayoutAlign="center center" class="actions">
                <button mat-raised-button color="warn" (click)="cancel()" style="margin-right:10px; z-index:9998;">
                    <mat-icon>close</mat-icon> Cancelar
                </button>
                <button mat-raised-button [disabled]="attachment.id" color="primary" (click)="insert()"
                    style="z-index:9998;">
                    <mat-icon>save</mat-icon> Salvar
                </button>
                <button fxHide.gt-sm mat-raised-button color="accent" (click)="showAttachmentHistory()"
                    style="z-index:9998;">
                    <mat-icon>history</mat-icon> Histórico
                </button>
            </div>
        </div>

        <!-- RIGHT SIDE (Historico) -->
        <div fxFlex.lt-md="100" fxFlex.gt-md="35" fxLayout="column" class="right-side"
            *ngIf="!isMobileView() || showHistoryMobile">

            <div fxHide.gt-sm fxLayout="row" fxLayoutAlign="space-between center" class="attachment-mobile-history-header">
                <span>Histórico dos Anexos</span>
                <button mat-icon-button (click)="returnToAttachmentForm()" title="Voltar para anexos" color="accent">
                    <mat-icon>arrow_back</mat-icon>
                </button>
            </div>

            <h1 fxHide.lt-md fxLayoutAlign="center center" mat-dialog-title>Histórico dos Anexos</h1>

            <!-- Mobile: Dropdown -->
            <div fxHide.gt-sm class="attachment-mobile-list">
                <button type="button" class="attachment-mobile-item" *ngFor="let attachment of attachmentList"
                    (click)="selectRow(attachment)">
                    <mat-icon>{{getIconChip(attachment.eartefact.type)}}</mat-icon>
                    <span>{{attachment.name}}</span>
                </button>
            </div>

            <!-- Desktop: Lista -->
            <div fxHide.lt-md class="h-100-p " style="overflow:auto;">
                <mat-chip-list class="w-90-p ml-10" style="margin-left:10px;" aria-label="Histórico de anexos">
                    <mat-chip class="w-100-p h-10-p ml-10" *ngFor="let chip of attachmentList" selected
                        [color]="getColorChip(chip.eartefact.type)" (click)="selectRow(chip)">
                        <div fxLayout="column" class="w-100-p">
                            <div fxLayout="row" fxLayoutAlign="space-between center">
                                <div>
                                    <mat-icon>{{getIconChip(chip.eartefact.type)}}</mat-icon> {{chip.name}}
                                </div>
                                <div>
                                    <button mat-icon-button title="Deletar" (click)="deleteAttachement(chip)">
                                        <mat-icon>delete</mat-icon>
                                    </button>
                                    <button mat-icon-button title="Download" (click)="download(chip)">
                                        <mat-icon>cloud_download</mat-icon>
                                    </button>
                                </div>
                            </div>
                            <div>Profissional: {{chip.performer.professional.person.name + " Data:" + chip.dated}}</div>
                        </div>
                    </mat-chip>
                </mat-chip-list>
            </div>
        </div>
    </div>
</div>
